const SELECTOR = ".press-marquee--manual-scroll .press-marquee__manual-scroll";
const INTERACTIVE_SELECTOR = "a, button, input, select, textarea, label, summary";
const DRAG_THRESHOLD = 4;

const bindDragScroll = (scroller) => {
  if (scroller.dataset.dragScrollBound === "true") return;

  scroller.dataset.dragScrollBound = "true";

  let isDragging = false;
  let hasDragged = false;
  let startX = 0;
  let startScrollLeft = 0;
  let preventClick = false;

  const stopDragging = () => {
    if (!isDragging) return;

    isDragging = false;
    scroller.classList.remove("is-dragging");

    if (hasDragged) {
      preventClick = true;

      window.setTimeout(() => {
        preventClick = false;
      }, 0);
    }
  };

  scroller.addEventListener("pointerdown", (event) => {
    if (event.pointerType !== "mouse" || event.button !== 0) return;
    if (event.target.closest(INTERACTIVE_SELECTOR)) return;

    isDragging = true;
    hasDragged = false;
    startX = event.clientX;
    startScrollLeft = scroller.scrollLeft;
    scroller.classList.add("is-dragging");

    if (scroller.setPointerCapture) {
      try {
        scroller.setPointerCapture(event.pointerId);
      } catch {
        // noop
      }
    }
  });

  scroller.addEventListener("pointermove", (event) => {
    if (!isDragging) return;

    const deltaX = event.clientX - startX;

    if (!hasDragged && Math.abs(deltaX) < DRAG_THRESHOLD) {
      return;
    }

    hasDragged = true;
    scroller.scrollLeft = startScrollLeft - deltaX;
    event.preventDefault();
  });

  scroller.addEventListener("pointerup", stopDragging);
  scroller.addEventListener("pointercancel", stopDragging);
  scroller.addEventListener("lostpointercapture", stopDragging);

  scroller.addEventListener("dragstart", (event) => {
    event.preventDefault();
  });

  scroller.addEventListener(
    "click",
    (event) => {
      if (!preventClick) return;

      event.preventDefault();
      event.stopPropagation();
    },
    true,
  );
};

const initPressMarquee = (root = document) => {
  root.querySelectorAll(SELECTOR).forEach(bindDragScroll);
};

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => {
    initPressMarquee();
  });
} else {
  initPressMarquee();
}

document.addEventListener("shopify:section:load", (event) => {
  initPressMarquee(event.target);
});
